import { Pipe, PipeTransform } from "@angular/core";
import { localize } from "@gtmhub/localization";
import dayjs from "@webapp/shared/libs/dayjs";
import { getWeekDayTranslationKey, isDateInCurrentWeek, isDateInThePast } from "./utils";

@Pipe({
  name: "dueDate",
  standalone: true,
})
export class DueDatePipe implements PipeTransform {
  public transform(dueDate: string | dayjs.Dayjs | Date): string {
    if (!dueDate) {
      return "";
    }

    const date = dayjs(dueDate);

    if (isDateInThePast(date)) {
      return localize("overdue");
    }

    if (date.isToday()) {
      return localize("due_today");
    }

    if (date.isTomorrow()) {
      return localize("due_tomorrow");
    }

    if (isDateInCurrentWeek(date)) {
      return localize("due_on", { day: localize(getWeekDayTranslationKey(date)) });
    }

    return localize("due_on", { day: date.format("DD MMM") });
  }
}
